import React, { Component } from "react";

class SocialLinksIcons extends Component {

    render() {
        const childLinks = this.props.children
        return (
            <div className="bottom">
                <ul className="icons">
                    {React.Children.map(childLinks, (child, i) => {
                        return <li>{child}</li>
                    })}
                </ul>
            </div>
        );
    }
}

export default SocialLinksIcons;